
import React from 'react';
import { useDispatch, useSelector  } from 'react-redux';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import {
    CloseButton,
    IfComp,
    PanelSectionTitle
} from '../../../core';

import {
    getMapDataMapping,
    useDataProjectId,
    useToken
} from '../../../project';

import { getActions } from '../../sagas';
import useDatawinDataModelItem from '../../hooks/useDatawinDataModelItem';
import useDatawinFetchAttributes from '../../hooks/useDatawinFetchAttributes';
import useDatawinFetchGeom from '../../hooks/useDatawinFetchGeom';
import useDatawinFetchAttributeVisibility from '../../hooks/useDatawinFetchAttributeVisibility';
import useDatawinFetchPanelVisibility from '../../hooks/useDatawinFetchPanelVisibility';

import FetchAttributeList from './FetchAttributeList';

const FetchObjectsPanel = ({}) => {

    const classNames = mergeStyleSets({
        FetchObjectsPanel: {
            paddingTop: 16,
            paddingLeft: 12,
            marginRight: 8,
            boxShadow: 'rgba(0, 0, 0, 0.1) 8px 0px 8px -8px',
            width: 340
        }
    });

    const dispatch = useDispatch();
    const dataActions = getActions(dispatch);

    const token = useToken();
    const projectId = useDataProjectId();
    const dataModelItem = useDatawinDataModelItem();
    const fetchAttributes = useDatawinFetchAttributes(dataModelItem.id);
    const fetchGeom = useDatawinFetchGeom(dataModelItem.id);
    const fetchAttributeVisibility = useDatawinFetchAttributeVisibility(dataModelItem.id);
    const fetchPanelVisibility = useDatawinFetchPanelVisibility();
    const mapDataMapping = useSelector(state => getMapDataMapping(state.project));

    const handleCloseClick = () => {
        dataActions.setDatawinFetchPanelVisibility(false);
    }

    const handleChangeAttributes = (attributes) => {
        dataActions.setDatawinFetchAttributes(dataModelItem.id, attributes);
    }

    const handleChangeAttributeVisibility = (values) => {
        dataActions.setDatawinFetchAttributeVisibility(dataModelItem.id, values);
    }

    const handleChangeGeom = (geom) => {
        dataActions.setDatawinFetchGeom(dataModelItem.id, geom);
    }

    const handleFetch = (mode, values, geom) => {
        dataActions.fetchObjects(
            token, projectId, dataModelItem.id, mapDataMapping.data[dataModelItem.id],
            {mode, attributes: values, geom: geom}
        );
    }

    return (
        <IfComp cond={fetchPanelVisibility}>
            <Stack verticalFill className={classNames.FetchObjectsPanel} >
                <Stack horizontal verticalAlign="center" >
                    <Stack.Item grow>
                        <PanelSectionTitle title="Parametry pro načtení objektů" />
                    </Stack.Item>
                    <CloseButton onClick={handleCloseClick} />
                </Stack>
                <Stack verticalFill >
                    <Stack.Item grow>
                        <FetchAttributeList
                            attributes={fetchAttributes}
                            attributeVisibility={fetchAttributeVisibility}
                            dataModelItem={dataModelItem}
                            geom={fetchGeom}
                            onChangeAttributes={handleChangeAttributes}
                            onChangeAttributeVisibility={handleChangeAttributeVisibility}
                            onChangeGeom={handleChangeGeom}
                            onFetch={handleFetch}
                        />
                    </Stack.Item>
                </Stack>
            </Stack>
        </IfComp>
    );
}

export default FetchObjectsPanel;
